module.exports = __webpack_public_path__ + "static/img/scissor.4f5d83dc.svg";